import { FC, SVGProps } from "react";

type Props = SVGProps<SVGSVGElement>;

/**
 * YouTube logo icon component
 */
export const YouTubeLogo: FC<Props> = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.9932 4.30206C11.9932 4.30206 5.11728 4.30207 3.39152 4.7505C2.46749 5.00868 1.70662 5.76956 1.44844 6.70718C1.00001 8.43294 1 12.0068 1 12.0068C1 12.0068 1.00001 15.5943 1.44844 17.2929C1.70662 18.2305 2.4539 18.9778 3.39152 19.236C5.13087 19.698 11.9932 19.698 11.9932 19.698C11.9932 19.698 18.8827 19.698 20.6084 19.2496C21.5461 18.9914 22.2933 18.2577 22.5379 17.3065C22.9999 15.5943 23 12.0204 23 12.0204C23 12.0204 23.0135 8.43294 22.5379 6.70718C22.2933 5.76956 21.5461 5.02229 20.6084 4.77769C18.8827 4.30208 11.9932 4.30206 11.9932 4.30206ZM9.80538 8.70486L15.5263 12.0068L9.80538 15.2952V8.70486Z"
      fill="currentColor"
    />
  </svg>
);
